import { css } from "styled-components";

export const DashboardCustomizeDragNDropCss = css`
    --ant-box-shadow-secondary: 0 6px 16px 0 rgba(0, 0, 0, 8%), 0 3px 6px -4px rgba(0, 0, 0, 12%), 0 9px 28px 8px rgba(0, 0, 0, 5%);

    .sortable-helper-dashboard {
        opacity: 0.7;

        .inner-item {
            cursor: pointer;
            box-shadow: var(--ant-box-shadow-secondary);
            transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.5s linear;
            transform: scale(0.99) !important;
        }
    }
`;
